import React from "react"
import {Link} from "gatsby"
import LogoImg from "../../images/jam-seo-tools-logo.png"

import "./style.scss"

const Header = () => {
  return (
    <header className="header">
      <Link to="/">
        <img src={LogoImg} width="300" alt="JAM SEO tools colorful text." />
      </Link>
      <nav>
        <Link to="/">Home</Link>
        <a
          href="https://www.producthunt.com/posts/jam-seo-tools?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-jam-seo-tools"
          target="_blank" rel="noopener noreferrer">
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=279609&theme=light"
            alt="JAM SEO tools - Free blog post SEO optimization tools ala Yoast for JAMstack | Product Hunt"
            style={{width: "250px", height: "54px"}}
          />
        </a>
      </nav>
    </header>
  )
}

export default Header
